import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import {
  getBrandRiderDashboardByDays,
  getBrandStore,
  getBrandUsers,
} from "../../../services/StoreUsers/PostStoreUsers";
import {
  formatDate,
  formatDateNewWithTime,
} from "../../../constants/DateUtil/DateUtil";
import { ProgressSpinner } from "primereact/progressspinner";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { FloatLabel } from "primereact/floatlabel";
import AdminMenu from "../../AdminMenu";
import {
  getCustomerOnlinePaymentList,
  updateCustomerOnlinePayment,
} from "../../../services/CustomerInfo/CustomerInfo";
import { errorMessage, successMessage } from "../../../utils/alertMessage";
import { Dialog } from "primereact/dialog";
import FinanceAdminMenu from "../../FinanceAdminMenu";
import { Calendar } from "primereact/calendar";

const CustomerOnlinePayment = () => {
  const navigate = useNavigate();
  const [switchRiderUserModalVisible, setSwitchRiderUserModalVisible] =
    useState(false);
  const [storeUserData, setStoreUserData] = useState([]);
  const [storeData, setStoreData] = useState([]);
  const [selectedUserItemValue, setSelectedUserItemValue] = useState(null);
  const [assignStoreValue, setAssignStoreValue] = useState("");

  const [visible, setVisible] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  const userRole = userProfileRole;
  let brandId = brandProfileData.id;
  const [loading, setLoading] = useState(false);
  const [storeId, setStoreId] = useState(null);

  const [customerOnlinePaymentList, setCustomerOnlinePaymentList] = useState(
    [],
  );

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate() - 7); // subtract 7 days to current date

  const [startDate, setStartDate] = useState(new Date(initialStartDate));

  const minimumInitialDate = new Date(brandProfileData.createdDate);
  // minimumInitialDate.setMonth(minimumInitialDate.getMonth() - 1000);

  let initialEndDate = new Date();
  const [endDate, setEndDate] = useState(new Date(initialEndDate));

  const [minimumDate, setMinimumDate] = useState(minimumInitialDate);
  const [maximumDate, setMaximumDate] = useState(new Date());

  const [displayCustomerPaymentUpdate, setDisplayCustomerPaymentUpdate] =
    useState(false);

  const [searchText, setSearchText] = useState("");
  const [submitButtonPressed, setSubmitButtonPressed] = useState(false);
  const [selectedStatusValue, setSelectedStatusValue] = useState("");
  const [selectedItem, setSelectedItem] = useState({});
  const [updatedTransactionId, setUpdatedTransactionId] = useState("");

  const statusList = ["SUCCESS", "FAILED"];

  const handleStartDateChange = (selectedDate) => {
    if (selectedDate) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const utcDate = new Date(
        Date.UTC(
          selectedDate.getFullYear(),
          selectedDate.getMonth(),
          selectedDate.getDate(),
        ),
      );

      if (utcDate > today) {
        alert("Start date cannot be a future date.");
      } else {
        setStartDate(utcDate);
        setMaximumDate(today); // optional: restrict end date to today
      }
    }
  };

  const handleEndDateChange = (selectedDate) => {
    if (selectedDate) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const utcDate = new Date(
        Date.UTC(
          selectedDate.getFullYear(),
          selectedDate.getMonth(),
          selectedDate.getDate(),
        ),
      );

      if (utcDate > today) {
        alert("End date cannot be a future date.");
        return;
      }

      if (!startDate) {
        alert("Please select a start date first.");
        return;
      }

      if (utcDate < startDate) {
        alert("End date cannot be before start date.");
        return;
      }

      setEndDate(utcDate);
    }
  };

  const handleAssignStoreChange = (selectedItem) => {
    setAssignStoreValue(selectedItem);
    setStoreId(selectedItem);
  };

  const fetchStoreUser = () => {
    getBrandStore(brandId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          // const ResFilter = Res.filter((item) => item.enabledSwitchStoreUser === true);
          const newRes = Res.map((item) => ({
            name: item.storeName,
            value: item.id,
          }));
          setStoreData(newRes);
          // setStoreId(Res[0].id);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const fetchCustomerOnlinePayment = (storeId) => {
    setLoading(true);
    getCustomerOnlinePaymentList(storeId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setCustomerOnlinePaymentList(Res);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchStoreUser();
  }, []);

  useEffect(() => {
    if (storeId > 0) {
      const inputRegex = /^\d*$/;

      if (!inputRegex.test(searchText)) return;

      const data = {
        storeIdIn: [storeId],
        statusIn: ["requested"],
        storeCustomerIdIn: [],
        tranTypeIn: ["Subscription"],
        receivedByIn: [],
        searchBy: "customerMobile",
        searchText: searchText,
        startDate: startDate,
        endDate: endDate,
        sortOrder: "desc",
        sortBy: "id",
        limit: 15,
        offset: 0,
      };

      fetchCustomerOnlinePayment(data);
    }
  }, [storeId, searchText, startDate, endDate]);

  const onClickCustomerPaymentUpdate = (item) => {
    setDisplayCustomerPaymentUpdate(true);
    setSelectedItem(item);
    setUpdatedTransactionId(item?.transactionId);
  };

  const onHideCustomerPaymentUpdate = () => {
    setDisplayCustomerPaymentUpdate(false);
  };

  const renderDialogCustomerPaymentUpdate = () => (
    <Dialog
      header="Update Payment"
      visible={displayCustomerPaymentUpdate}
      onHide={() => onHideCustomerPaymentUpdate()}
      breakpoints={{ "960px": "75vw" }}
      style={{ width: "50vw" }}
    >
      <div>
        <div className="row mb-3">
          <div className="col-md-6">
            <label htmlFor="qrCodeCount" className="form-label">
              Amount
            </label>
            <InputText
              type="text"
              style={{ width: "100%" }}
              id="Amount"
              name="Amount"
              placeholder="Amount"
              value={selectedItem.amount}
              disabled
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="qrCodeCount" className="form-label">
              Transaction Id
            </label>
            <InputText
              type="text"
              style={{ width: "100%" }}
              id="TransactionId"
              name="Transaction Id"
              placeholder="Transaction Id"
              value={updatedTransactionId}
              onChange={(e) => {
                setUpdatedTransactionId(e.target.value);
              }}
            />
          </div>
        </div>

        <div className="row mb-3 mx-0">
          <Dropdown
            value={selectedStatusValue}
            options={statusList}
            onChange={(e) => {
              setSelectedStatusValue(e.target.value);
            }}
            placeholder="Select Status"
          />
        </div>

        <div className="col-md-12 text-center">
          <button
            type="submit"
            className="move-btn move-btn-su"
            onClick={handleCustomerPaymentUpdate}
            disabled={submitButtonPressed}
          >
            Submit
          </button>
        </div>
      </div>
    </Dialog>
  );

  const handleCustomerPaymentUpdate = () => {
    const data = {
      id: selectedItem?.id,
      status: selectedStatusValue,
      transactionId: updatedTransactionId,
    };

    setSubmitButtonPressed(true);

    updateCustomerOnlinePayment(data)
      .then((response) => {
        const Res = response.data;
        // handle the response
        if (Res.status === true) {
          successMessage(Res.message);

          setDisplayCustomerPaymentUpdate(false);
          setSubmitButtonPressed(false);
          const data = {
            storeIdIn: [storeId],
            statusIn: ["requested"],
            storeCustomerIdIn: [],
            tranTypeIn: ["Subscription"],
            receivedByIn: [],
            searchBy: "customerMobile",
            searchText: searchText,
            startDate: startDate,
            endDate: endDate,
            sortOrder: "desc",
            sortBy: "id",
            limit: 15,
            offset: 0,
          };

          fetchCustomerOnlinePayment(data);
        } else {
          errorMessage(Res.message);
          setSubmitButtonPressed(false);

          setDisplayCustomerPaymentUpdate(false);
          const data = {
            storeIdIn: [storeId],
            statusIn: ["requested"],
            storeCustomerIdIn: [],
            tranTypeIn: ["Subscription"],
            receivedByIn: [],
            searchBy: "customerMobile",
            searchText: searchText,
            startDate: startDate,
            endDate: endDate,
            sortOrder: "desc",
            sortBy: "id",
            limit: 15,
            offset: 0,
          };

          fetchCustomerOnlinePayment(data);
        }
      })
      .catch((error) => {
        // handle errors
        errorMessage("Customer Upload Failed");

        setSubmitButtonPressed(false);
        setDisplayCustomerPaymentUpdate(false);
      });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => {
                    userRole === "BY_ACCOUNTANT"
                      ? navigate("/")
                      : navigate("/Setting");
                  }}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Customer Online Payment
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div>
        <div className="mt-4 mb-3 mx-4 flex-1 flex flex-row">
          <div className=" flex-1">
            <FloatLabel>
              <Dropdown
                id="assignStoreValue"
                value={assignStoreValue}
                onChange={(e) => handleAssignStoreChange(e.target.value)}
                options={storeData}
                optionLabel="name"
                placeholder="Store"
                className="w-full border-round-xl  text-2xl text-xl shadow-2"
              />
              <label
                htmlFor="assignStoreValue"
                className="text-md"
                style={{ color: "blue" }}
              >
                Store <span style={{ color: "red" }}>*</span>
              </label>
            </FloatLabel>
          </div>
          {assignStoreValue && (
            <div className=" ml-4 flex-1">
              <FloatLabel>
                <InputText
                  type="text"
                  style={{ width: "100%" }}
                  id="search"
                  name="Search"
                  className="w-full border-round-xl  text-lg shadow-2"
                  placeholder="Search Customer By Mobile No."
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                  }}
                />
                <label
                  htmlFor="assignStoreValue"
                  className="text-md"
                  style={{ color: "blue" }}
                >
                  Search Customer By Mobile No.
                </label>
              </FloatLabel>
            </div>
          )}
        </div>
        {assignStoreValue && (
          <div className="mt-2 mb-3 mx-4 flex-1 flex flex-row">
            <div className="flex-1">
              <p className="font-bold block ml-2 mb-1">Start Date</p>
              <Calendar
                id="buttondisplay"
                value={startDate}
                onChange={(e) => handleStartDateChange(e.value)}
                showIcon
                minDate={minimumDate}
                maxDate={new Date()}
                className="w-full border-round-lg p-1 text-lg text-primary-50"
                dateFormat="dd/mm/yy"
              />
            </div>

            <div className="ml-3 flex-1">
              <p className="font-bold block ml-2 mb-1">End Date</p>
              <Calendar
                id="buttondisplay"
                value={endDate}
                onChange={(e) => handleEndDateChange(e.value)}
                showIcon
                minDate={startDate}
                maxDate={maximumDate}
                className="w-full border-round-lg p-1 text-lg text-primary-50"
                dateFormat="dd/mm/yy"
              />
            </div>
          </div>
        )}
      </div>
      <div>
        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : storeId === null || "" ? (
          <div className="flex justify-content-center">
            <p className="text-xl font-medium">Please Select Store</p>
          </div>
        ) : customerOnlinePaymentList.length > 0 ? (
          <div>
            <main id="main" className="main mb-3 mx-4">
              <section className="section">
                <div className="col-lg-12">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>Customer Name</th>
                        <th>Customer Mobile</th>
                        <th>Created Date</th>
                        <th>Payment Type</th>
                        <th>Amount</th>
                        <th>Transaction Id</th>
                        <th>Status</th>
                        <th>Edit</th>
                      </tr>
                    </thead>
                    <tbody>
                      {customerOnlinePaymentList.map((item, index) => (
                        <tr>
                          <td>{index + 1}</td>
                          <td>{item.customerName}</td>
                          <td>{item.customerMobile}</td>
                          <td>{formatDateNewWithTime(item.createdDate)}</td>
                          <td>
                            {item.subscriberId ? "Subscription" : "Order"}
                          </td>
                          <td>{item.amount}</td>
                          <td>{item.transactionId}</td>
                          <td>{item.status}</td>

                          <td>
                            {item.processed === false &&
                              item.status === "requested" && (
                                <button
                                  type="button"
                                  className="btn"
                                  onClick={() =>
                                    onClickCustomerPaymentUpdate(
                                      item,
                                      "displayCustomerPaymentUpdate",
                                    )
                                  }
                                >
                                  <i
                                    className="pi pi-upload"
                                    style={{ color: "blue", fontSize: "20px" }}
                                  ></i>
                                </button>
                              )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </section>
            </main>
          </div>
        ) : (
          <div className="flex justify-content-center">
            <p className="text-xl font-medium">No Order Found</p>
          </div>
        )}
      </div>

      {userRole === "BY_ACCOUNTANT" ? (
        <FinanceAdminMenu setVisible={setVisible} visible={visible} />
      ) : (
        <AdminMenu setVisible={setVisible} visible={visible} />
      )}

      <div>{renderDialogCustomerPaymentUpdate()}</div>
    </div>
  );
};

export default CustomerOnlinePayment;
